<template>
  <div id="result" style="height: 100vh;">
    <v-btn @click="scanCodeV2()">test</v-btn>
    <!-- <qrcode-stream :camera="camera" @decode="onDecode" @init="onInit">
      <v-row style="background-color:black;opacity: 0.5;">
        <v-col cols="6" style="padding-bottom: 0;">
          <button style="margin-top: 2px;" @click="goBack()">
            <v-avatar>
              <v-icon size="34px" style="color: white;"
                >mdi-chevron-left</v-icon
              >
            </v-avatar>
          </button>
        </v-col>
        <v-col cols="6" style="padding-bottom: 0;">
          <qrcode-capture @decode="onDecodeImge" style="margin-top: 2px;position:absolute;">
          </qrcode-capture>
          <button
            style="margin-top: 2px;position:absolute;right:30px;"
            @click="switchCamera"
          >
            <v-avatar>
              <v-icon size="34px" style="color: white;">mdi-cached</v-icon>
            </v-avatar>
          </button>
        </v-col>
      </v-row>
    </qrcode-stream> -->
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { QrcodeStream, QrcodeCapture } from 'vue-qrcode-reader'
export default {
  components: { QrcodeStream, QrcodeCapture },

  data () {
    return {
      camera: 'rear',
      noRearCamera: false,
      noFrontCamera: false,
      result: null,
      a: null
    }
  },
  async mounted () {
    this.scanCodeV2()
  },
  methods: {
    ...mapGetters('lineStore', ['liffIsReady', 'getLiffProfile']),
    ...mapGetters('memberStore', ['GET_MEMBERINFO']),

    async scanCodeV2 () {
      try {
        const result = await this.$liff.scanCodeV2()
        document.querySelector('#result').innerHTML = result.value
      } catch (error) {
        console.error('scanCodeV2', error)
        alert(error)
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/QrcodeScan/qrcodescan.vue